import React from "react";
import "./required.scss"

export default function Required() {
    return (
        <React.Fragment>
            <span className="required-asterisk" aria-hidden="true">*</span>
        </React.Fragment>
    );
};